import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { smooth } from './home/v3/motion';

/**
 * Nova rota começa no topo, instantaneamente (a troca acontece atrás do portal).
 * Com Lenis ativo, o reset precisa passar por ele, senão ele anima de volta.
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    if (smooth.lenis) smooth.lenis.scrollTo(0, { immediate: true, force: true });
    window.scrollTo(0, 0);
    // A página nova cria seus próprios gatilhos; recalcula depois que ela monta.
    const id = window.setTimeout(() => ScrollTrigger.refresh(), 120);
    return () => window.clearTimeout(id);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
